@if (device) {
    <div>
        <div class="device-label-container">
            <web-device-type-label
                class="headline-bold"
                [type]="device.storeyType ? DeviceTypeEnum.STOREY : device.panelType"
                [surname]="device.name"
            />
            <ng-content select="[optimizeButton]"></ng-content>
            <ng-content select="[detailsButton]"></ng-content>
        </div>
        @if (device.type === DeviceType3D.SOLAR_PANEL || device.type === DeviceType3D.METER) {
            <div class="status-container">
                @if (device.state === DeviceState.CONNECTED) {
                    <ng-container>
                        @if (device.type === DeviceType3D.SOLAR_PANEL || (isMeter && device.hasProducerPhase)) {
                            @let production = isMeter ? formatInstantPower(device.production) : null;
                            <div>
                                <div class="sub-headline">{{ 'GLOBAL.PRODUCTION' | translate }}</div>
                                <web-fading-span
                                    [value]="
                                        production ? production.value : device.production ? device.production : '-'
                                    "
                                    [suffix]="production ? production.suffix : device.production ? 'W' : ''"
                                    [autorizeZero]="isMeter"
                                ></web-fading-span>
                            </div>
                        }
                        @if (
                            device.panelType === PanelType.PLAY_MAX ||
                            (isMeter && device.hasProducerPhase && hasConsumption)
                        ) {
                            <hr class="vertical" />
                        }
                        @if (device.panelType === PanelType.PLAY_MAX) {
                            <div>
                                <div class="row">
                                    @if (device.batteryState) {
                                        <web-batterie-icon [batterieState]="device.batteryState"></web-batterie-icon>
                                    }
                                    <div class="column">
                                        <div class="sub-headline">{{ 'GLOBAL.BATTERY' | translate }}</div>
                                        <web-fading-span
                                            [value]="device.has_b ? device.battery : '-'"
                                            [suffix]="device.has_b ? '%' : ''"
                                        ></web-fading-span>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (hasConsumption) {
                            <div>
                                <div class="sub-headline">{{ 'GLOBAL.CONSUMPTION_SHORT' | translate }}</div>
                                <web-fading-span
                                    [value]="device.totalDevicesConsumption ?? 0"
                                    suffix="W"
                                    [autorizeZero]="true"
                                ></web-fading-span>
                            </div>
                        }
                    </ng-container>
                } @else {
                    <div>
                        <div class="sub-headline">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <web-fading-span
                            class="sub-headline-regular small-line-height"
                            prefixImg="solar-lost-connection.svg"
                            value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                            valueClass="white flex"
                            imgClass="red flex"
                        ></web-fading-span>
                    </div>
                }
            </div>
        }
        @if (device.type === DeviceType3D.GRID) {
            <div class="status-container">
                @if (device.state === DeviceState.CONNECTED) {
                    <ng-container>
                        <div>
                            <div class="sub-headline">{{ 'GLOBAL.PURCHASED' | translate }}</div>
                            <web-fading-span
                                [value]="
                                    (checkNumberAndGreaterThanOrEqualZero(device.purchased) && canHaveSellBack()) ||
                                    (!canHaveSellBack() && device.purchased)
                                        ? device.purchased
                                        : '-'
                                "
                                [suffix]="
                                    (checkNumberAndGreaterThanOrEqualZero(device.purchased) && canHaveSellBack()) ||
                                    (!canHaveSellBack() && device.purchased)
                                        ? 'W'
                                        : ''
                                "
                                [autorizeZero]="canHaveSellBack()"
                            ></web-fading-span>
                        </div>
                        <hr class="vertical" />
                        <div>
                            @if (device.isSellBack) {
                                <div class="sub-headline">{{ 'GLOBAL.SOLD' | translate }}</div>
                            } @else {
                                <div class="sub-headline">{{ 'GLOBAL.REINJECTED' | translate }}</div>
                            }
                            <web-fading-span
                                [value]="canHaveSellBack() ? device.sold : '-'"
                                [suffix]="canHaveSellBack() ? 'W' : ''"
                                [autorizeZero]="canHaveSellBack()"
                            ></web-fading-span>
                        </div>
                    </ng-container>
                } @else {
                    <div>
                        <div class="sub-headline">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <web-fading-span
                            class="sub-headline-regular small-line-height"
                            prefixImg="erl-lost-connection.svg"
                            value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                            valueClass="white flex"
                            imgClass="red flex"
                            suffixClass="wrap"
                        ></web-fading-span>
                    </div>
                }
            </div>
        }
        @if (device.type === DeviceType3D.STOREY) {
            <div class="status-container">
                @if (device.batteryState === BatteryState.INITIALIZING) {
                    <div>
                        <div class="sub-headline">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <div class="initialize-container">
                            <ion-icon
                                class="loader"
                                slot="icon-only"
                                src="assets/icon/loader.svg"
                                color="light"
                            ></ion-icon>
                            <web-fading-span
                                class="sub-headline-regular small-line-height"
                                value="{{ 'GLOBAL.BATTERY_STATE.INITIALIZING' | translate }}"
                                valueClass="white flex"
                                suffixClass="wrap"
                            ></web-fading-span>
                        </div>
                    </div>
                } @else if (device.batteryState === BatteryState.DEVICE_OFF) {
                    <div>
                        <div class="sub-headline">{{ 'GLOBAL.STATUS' | translate }}</div>
                        <web-fading-span
                            class="sub-headline-regular small-line-height"
                            prefixImg="storey-lost-connection.svg"
                            value="{{ 'PAGES.OVERVIEW.LOST_CONNECTION' | translate }}"
                            valueClass="white flex"
                            imgClass="red flex"
                            suffixClass="wrap"
                        ></web-fading-span>
                    </div>
                } @else {
                    <div class="row">
                        @if (device.batteryState) {
                            <web-batterie-icon [batterieState]="device.batteryState"></web-batterie-icon>
                        }
                        <div class="column">
                            <div class="sub-headline">{{ 'GLOBAL.AVAILABLE' | translate }}</div>
                            <div class="row">
                                <web-fading-span
                                    [value]="device.soc ? device.soc : '-'"
                                    [suffix]="device.soc ? '%' : ''"
                                ></web-fading-span>
                                <hr class="vertical info" />
                                <web-fading-span
                                    [value]="device.storedEnergyKwh ? (device.storedEnergyKwh | absolute) : '-'"
                                    [suffix]="device.storedEnergyKwh ? ('GLOBAL.WH' | translate) : '-'"
                                ></web-fading-span>
                            </div>
                        </div>
                        <ng-content select="[webBatteryPausedInfo]"></ng-content>
                        @if (device.batteryState !== BatteryState.OFF && !batteryPausedInfo()) {
                            <hr class="vertical" />
                            <div>
                                <div class="sub-headline">
                                    {{ 'GLOBAL.BATTERY_STATE.' + device.batteryState | translate }}
                                </div>
                                <web-fading-span
                                    [value]="device.power ? (device.power | absolute) : '-'"
                                    [suffix]="device.power ? 'W' : ''"
                                ></web-fading-span>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
